import reloadApp from '../globs/utils/reload-app';

export default function appReload() {
  return () => {
    reloadApp();
  };
}
